import {connect} from "react-redux";
import {submitPayment} from "../../../api/server-api";
import {getQuotePriceWithTaxes, getTotalPrice} from "../../../misc/helpers";

const WithPaymentSubmit = (props) => {

  const {children, cardInfo, cardErrors, shippingAddress, billingAddress, billingSameAsShipping, deposit, jobId} = props;
  const {cardNumber, cardName, expMonth, expYear, cvv, country} = cardInfo;

  const getPaymentAmount = () => {
    const totalPrice = getTotalPrice();
    const grandTotal = getQuotePriceWithTaxes(totalPrice);
    return deposit ? Math.floor((grandTotal * (deposit / 100)) * 100) / 100 : grandTotal;
  }

  const paymentSubmit = async () => {
    console.log("cardErrors", cardErrors); // todo validation here
    return await submitPayment({
      name: cardName,
      ccNum: cardNumber,
      expMonth,
      expYear,
      cvv,
      zipCode: billingAddress.postal,
      country,
      amount: getPaymentAmount(),
      fabricatorId: document.kvConfig.userId,
      jobId: document.kvConfig.jobId || jobId,
      shippingAddress: {
        name: shippingAddress.fullName,
        address1: shippingAddress.address1,
        address2: shippingAddress.address2,
        city: shippingAddress.city,
        state: shippingAddress.state,
        zip: shippingAddress.postal
      },
      billingAddress: {
        name: billingAddress.fullName,
        address1: billingAddress.address1,
        address2: billingAddress.address2,
        city: billingAddress.city,
        state: billingAddress.state,
        zip: billingAddress.postal
      },
      billingSameAsShipping,
    }, true)
  }

  return children(paymentSubmit)
};

const mapStateToProps = (store) => {
  const {cardInfo, cardErrors, shippingAddress, billingAddress, billingSameAsShipping} = store.paymentState;
  const {jobId} = store.serverState;

  return {
    cardInfo,
    cardErrors,
    shippingAddress,
    billingAddress,
    jobId,
    billingSameAsShipping,
  }
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(WithPaymentSubmit)
